import {Injectable} from "@angular/core";
import {Action, createSelector, Store} from "@ngrx/store";
import {IAppState} from "../store/state/app.state";
import {combineLatest, empty, fromEvent, Observable, of, timer} from "rxjs";
import {
    DuplicateCommand,
    EnumConnectionType,
    EnumLoginViewMode,
    EnumStationFilterType,
    IAdnetState,
    IAppSettingsWrap,
    IAppStatic,
    IBusinessDomainCollection,
    ICart,
    ICartProduct,
    ICatalogItemCategories,
    ICatalogItemInfos,
    ICatalogItemResources,
    ICatalogItems,
    ICategoryValues,
    IChangeListIds,
    ICRUDScene,
    Id,
    IDynawebsServerReply,
    IEventBlock,
    IEventParam,
    ILocalStorageUpdates,
    ILockedRecord,
    ILog,
    ILoginForm,
    IMusicChannel,
    IMusicChannelSong,
    IOrderDetails,
    IOrderForm,
    IOS,
    IPaintSource,
    IPreloadResellerInfo,
    IResource,
    IResourceStatistic,
    IPlayerProps,
    ISceneTemplateImport,
    ISceneTreeSliceResults,
    ISchedule,
    IScheduleEvent,
    IScheduleSelection,
    ISelectedSceneSceneId,
    ISharedResourceLibrary,
    IStation,
    IStationData,
    IStationGeoIp,
    IStationStatsV1,
    ISVGConfig,
    ITransitionPool,
    ITransitionPoolItem, IUIConfigState,
    IUIDuplicationBlock,
    IUser,
    IUserState,
    PlatformStatic,
    IAnimationEngine, ISceneBlock, IGlobalSettings, IGlobalSettingKey, IPreferencesBusiness
} from "../interfaces";
import {DEFAULT_RESELLER_ID, formatBytes, getAllEventsInScenes, getPlayerIdInScene, isDigitNoEmpty, isMimeTypeExists, isNoValue, isNullOrUndefOrEmpty, isSceneDesktopEmpty, isSceneEmbedded, NONE_VALUE, sceneFindEventInScenes, SUPPORTED_FILE_TYPES} from "../common";
import {IBlockLabelProp, IBlockLabelsRecords, MimeAnomalyType} from "../containers/editor/scene-blocks/block-constants";
import {actionAccountSendEmail, actionLogger} from "../store/actions/user.actions";
import {IEnterpriseReseller, IGroupsPrivileges, IInstalledApp, IPrivileges, IStoreApps, IWhiteLabel} from "../interfaces/enterprise-interface";
import {IAccountDetails} from "../interfaces/enterprise-account-interface";
import {IBusinessAccount, IEnterpriseBusinesses} from "../interfaces/enterprise-businesses-interface";
import {IEnterpriseBusinessUsers} from "../interfaces/enterprise-business-users-interface";
import {List} from "immutable";
import {BusinessModel} from "../containers/adnet/models/BusinessModel";
import {AdnetCustomerModel} from "../containers/adnet/models/AdnetCustomerModel";
import {IAdnetCustomerCredentials} from "../interfaces/adnet-interfaces";
import {AdnetRateModel} from "../containers/adnet/models/AdnetRateModel";
import {AdnetTargetModel} from "../containers/adnet/models/AdnetTargetModel";
import { HttpClient } from "@angular/common/http";
import {AdnetPairModel} from "../containers/adnet/models/AdnetPairModel";
import {AdnetPackageModel} from "../containers/adnet/models/AdnetPackageModel";
import {AdnetReportModel} from "../containers/adnet/models/AdnetReportModel";
import {AdnetTransferModel} from "../containers/adnet/models/AdnetTransferModel";
import {AdnetPaymentModel} from "../containers/adnet/models/AdnetPaymentModel";
import {ISocialServerReply} from "../interfaces/social-interface";
import {SocialUser} from "@abacritt/angularx-social-login";
import {SceneMimeTypes} from "../containers/editor/scene-blocks/mime-constants";
import {TranslocoService} from "@ngneat/transloco";
import {ToastrService} from "ngx-toastr";
import {Lib} from "../../libs/Lib";
import {FasterqLineModel} from "../models/fasterq-line-model";
import {FasterqQueueModel} from "../models/fasterq-queue-model";
import {FasterqAnalyticsModel} from "../models/fasterq-analytics";
import {debounceTime, distinctUntilChanged, filter, map, mergeMap, take, takeWhile} from 'rxjs/operators';
import {ILocalStoreTypes, LocalStoreService} from "./local-store.service";
import {createHistorySelectors} from "ngrx-wieder";
import {IChatGlobal} from "../interfaces/chat-interface";
import {isArray} from "lodash";
import moment from 'moment';
import * as _ from "lodash";
import {isNullOrUndefined} from "util";

declare var platform: PlatformStatic;

const {version: version} = require('../../../package.json');

const selectFeature = (state: IAppState) => state.users;
const {
    selectCanUndo,
    selectCanRedo,
} = createHistorySelectors<IAppState, IUserState>(selectFeature);

@Injectable()
export class StoreSelectorsService {
    private m_blockLabelRecords: IBlockLabelsRecords;
    private m_addedBlockCount = 0;
    private m_user: IUser;

    private selectorGetUsers$;
    private selectorCombined$;

    constructor(private store: Store<IAppState>, private _http: HttpClient, private toastr: ToastrService, private translocoService: TranslocoService) {
        this.getUser()
            .subscribe((i_user: IUser) => {
                this.m_user = i_user;
            });
    }

    sendEmail(email, description, name, error) {
        if (error) {
            // require('platform');
            const info: any = platform.parse(platform.ua);
            const regex = RegExp('Edg');

            // firefox sucks
            const isFirefox = platform?.name?.toLowerCase()?.indexOf('firefox') > -1 || info?.name?.toLowerCase()?.indexOf('firefox') > -1;
            if (isFirefox) return;

            const platformInfo = `
                info ${info}<br/>
                name1: ${platform.name}<br/>
                name2: ${info.name}<br/>
                family: ${platform.os.family}<br/>
                description1: ${platform.description}<br/>
                description2: ${info.description}<br/>
                uaSting: ${platform.ua}<br/>
                isEdge: ${regex.test(platform.ua)}<br/>
                layout: ${info.layout}<br/>
                layout: ${info.layout}<br/>
                os: ${info.os}<br/>
                browserVersion: ${info.version}<br/>
                appVersion: ${version}<br/>
            `;
            description = `dump: ${description} <br/> ${platformInfo}`;
        }

        this.dispatch(actionAccountSendEmail({
            emailSend: {email, description, name}
        }));
    }

    set blockLabels(i_blockLabelRecords: IBlockLabelsRecords) {
        this.m_blockLabelRecords = i_blockLabelRecords;
    }

    get blockLabels(): IBlockLabelsRecords {
        return this.m_blockLabelRecords;
    }

    getBlockLabelImageTypes(): Array<string> {
        return [...this.getBlockLabelById(this.m_blockLabelRecords.IMAGE.id).types, ...this.getBlockLabelById(this.m_blockLabelRecords.SVG).types];
    }

    getBlockLabelVideoTypes(): Array<string> {
        return this.getBlockLabelById(this.m_blockLabelRecords.VIDEO.id).types;
    }

    getBlockLabelByFileType(type): IBlockLabelProp {
        let res;
        Object.keys(this.blockLabels).forEach((i_block) => {
            const block = this.blockLabels[i_block];
            if (!block.types) return;
            const idx = block.types.findIndex((z) => z === type);
            if (idx > -1) res = block;
        });
        res = _.cloneDeep(res);
        return res;
    }

    /** get block by mime type, allow, filter by jsonItemBased or not **/
    getBlockLabelByMimeType(mimeType: string, isJsonItemBased: boolean): IBlockLabelProp {
        const res = Object.values(this.blockLabels).find((block: IBlockLabelProp) => {
            if (isJsonItemBased) {
                if (block.id === '6500') {
                }
                if (!block.jsonItemBased) return false;
                if (isMimeTypeExists(block.types, mimeType)) return block;
            } else {
                if (block.jsonItemBased === true) return false;
                if (isMimeTypeExists(block.types, mimeType)) return block;
            }
        });
        return _.cloneDeep(res);
    }

    set addedBlockCount(i_addedBlockCount: number) {
        this.m_addedBlockCount = i_addedBlockCount;
    }

    get addedBlockCount(): number {
        return this.m_addedBlockCount;
    }

    getBlockLabelById(id, clone = true): IBlockLabelProp {
        let res = Object.values(this.blockLabels).find((k: IBlockLabelProp) => {
            if (k.id === id) {
                return k;
            }
        });
        /** default to DesktopPro if not found **/
        if (_.isUndefined(res)) res = this.getBlockLabelById('0');
        return clone ? _.cloneDeep(res) : res;
    }

    /** check if a block is actually aliased based, we can store the alias in different places in future as well **/
    isBlockIdJsonAliased(i_sceneItem: ISceneBlock): Id {
        const token = i_sceneItem.Data[0]?.Json?.[0]?.Data?.[0]?.$?.token;
        switch (token) {
            // case this.m_blockLabelRecords.NETFEED_HOROSCOPE.id:
            // case this.m_blockLabelRecords.NETFEED_NEWS.id: {
            //     return i_sceneItem.Data[0].Json[0].Data[0].$.token;
            // }
            default: {
                return i_sceneItem.$.player;
            }
        }
    }

    isBlockIdJsonItemBased(i_id: Id): boolean {
        const a = Object.values(this.m_blockLabelRecords).find((block: IBlockLabelProp) => {
            if (block.id === i_id) {
                if (block.name === 'JsonItem') {
                    return true;
                }
            }
        });
        return !!a;
    }

    isMainSceneOrPlayer(mimeType: string): boolean {
        return mimeType === SceneMimeTypes.Scene || mimeType === SceneMimeTypes.Player;
    }

    mineToName(mimeType: string) {
        return mimeType.replace(/Json./, '').replace(/\./ig, ' ');
    }

    isMainScenePlayerOnly(mimeType: string): boolean {
        return mimeType === SceneMimeTypes.Player;
    }

    isBlockIdJsonBased(i_id: Id): boolean {
        const a = Object.values(this.m_blockLabelRecords).find((block: IBlockLabelProp) => {
            if (block.id === i_id) {
                if (block.types.length > 0 && block.jsonPlayerBased) {
                    return true;
                }
            }
        });
        return !!a;
    }

    isBlockItemBased(i_id: Id): boolean {
        const a = Object.values(this.m_blockLabelRecords).find((block: IBlockLabelProp) => {
            if (block.id === i_id) {
                if (block.jsonItemBased) {
                    return true;
                }
            }
        });
        return !!a;
    }

    public isResourceBased(i_id: Id): boolean {
        const resourceIds = [
            this.m_blockLabelRecords.VIDEO.id,
            this.m_blockLabelRecords.IMAGE.id,
            this.m_blockLabelRecords.SVG.id
        ];
        return resourceIds.indexOf(i_id) > -1;
    }

    public getUserAccessMask(): Observable<Array<string>> {
        return this.getUser()
            .pipe(
                distinctUntilChanged((a, b) => {
                    return a.accessMask == b.accessMask;
                }),
                map((i_user: IUser) => {
                    const mask: Array<boolean> = Lib.GetAccessMask(i_user.accessMask);
                    return mask.map((v, i) => v ? String(i) : null).filter((z) => z !== null);
                })
            );
    }

    public getGroupsPrivileges(): Observable<IGroupsPrivileges> {
        return this.store.select(store => store.users.selectedUser?.groupsPrivileges).pipe(filter((v) => v !== null));
    }

    getBlockJsonBasedById(i_id: Id): IBlockLabelProp {
        const a = Object.values(this.m_blockLabelRecords).find((block: IBlockLabelProp) => {
            if (block.id === i_id) {
                if (block.types.length > 0 && block?.jsonPlayerBased) {
                    return true;
                }
            }
        });
        return a;
    }

    deleteInTemplates(component, path) {
        const c1 = _.cloneDeep(component);
        _.unset(c1, path);
        return c1;
    }

    swapTemplates(source, destination, mimeType) {
        if (this.isMainSceneOrPlayer(mimeType)) {
            return destination;
        } else {
            const c1 = _.cloneDeep(source);
            const c2 = _.cloneDeep(destination);
            c1.template = c2.template;
            return c1;
        }
    }

    /** adding component, is mime type is set on scene AND adding JsonBased, convert its component to JsonItemBased
     * @param(i_blockLabelIdOrMimeType) can be mimeType or blockLabel.id
     **/
    getComponentForBlock(i_blockLabelIdOrMimeType, mimeType: string): IBlockLabelProp {
        if (_.isNaN(Number(i_blockLabelIdOrMimeType))) {
            i_blockLabelIdOrMimeType = this.getBlockLabelByMimeType(i_blockLabelIdOrMimeType, false).id;
        }
        const blockLabelRecords = Object.assign({}, this.m_blockLabelRecords);
        const blockLabelId = String(i_blockLabelIdOrMimeType);
        let component: IBlockLabelProp;
        switch (blockLabelId) {
            case blockLabelRecords.BLOCKCODE_SCENE.id: {
                component = blockLabelRecords.BLOCKCODE_SCENE;
                break;
            }
            case blockLabelRecords.JSON_PLAYER.id: {
                component = blockLabelRecords.JSON_PLAYER;
                break;
            }
            // case blockLabelRecords.NETFEED_NEWS.id: {
            //     component = blockLabelRecords.NETFEED_NEWS;
            //     break;
            // }
            // case blockLabelRecords.NETFEED_HOROSCOPE.id: {
            //     component = blockLabelRecords.NETFEED_HOROSCOPE;
            //     break;
            // }
            case blockLabelRecords.JSON_VIEWER.id: {
                component = blockLabelRecords.JSON_VIEWER;
                component = this.deleteInTemplates(component, 'template.Data[0].Json[0].$.displayMode');
                break;
            }
            case blockLabelRecords.JSONITEM.id: {
                component = blockLabelRecords.JSONITEM;
                break;
            }
            case blockLabelRecords.SPREADSHEET.id: {
                component = this.swapTemplates(blockLabelRecords.JSONITEM, blockLabelRecords.SPREADSHEET, mimeType);
                break;
            }
            case blockLabelRecords.DRIVE.id: {
                component = this.swapTemplates(blockLabelRecords.JSONITEM, blockLabelRecords.DRIVE, mimeType);
                break;
            }
            case blockLabelRecords.CUSTOMRSS_ITEM.id: {
                component = blockLabelRecords.CUSTOMRSS_ITEM;
                // component = this.swapTemplates(blockLabelRecords.JSONITEM, blockLabelRecords.CUSTOMRSS_ITEM, mimeType);
                if (mimeType === SceneMimeTypes.CustomRss) {
                    component.template.$.player = blockLabelRecords.CUSTOMRSS_ITEM.id;
                }
                break;
            }
            case blockLabelRecords.CUSTOMRSS.id: {
                component = this.swapTemplates(blockLabelRecords.JSONITEM, blockLabelRecords.CUSTOMRSS, mimeType);
                if (this.isMainSceneOrPlayer(mimeType)) {
                    component.template.$.player = blockLabelRecords.CUSTOMRSS.id;
                }
                break;
            }
            case blockLabelRecords.CATALOG_ITEM.id: {
                component = this.swapTemplates(blockLabelRecords.JSONITEM, blockLabelRecords.CATALOG_ITEM, mimeType);
                component.template.$.player = blockLabelRecords.CATALOG_ITEM.id;
                break;
            }
            case blockLabelRecords.CATALOG.id: {
                if (this.isMainSceneOrPlayer(mimeType)) {
                    component = this.swapTemplates(blockLabelRecords.JSONITEM, blockLabelRecords.CATALOG, SceneMimeTypes.Player);
                    component.template.$.player = blockLabelRecords.CATALOG.id;
                } else {
                    component = blockLabelRecords.CATALOG_ITEM;
                    component.template.$.player = blockLabelRecords.CATALOG_ITEM.id;
                }
                break;
            }
            case blockLabelRecords.XML_ITEM.id: {
                component = blockLabelRecords.XML_ITEM;
                // component = this.swapTemplates(blockLabelRecords.JSONITEM, blockLabelRecords.XML_ITEM, mimeType);
                if (mimeType === SceneMimeTypes.XML) {
                    component.template.$.player = blockLabelRecords.XML_ITEM.id;
                }
                break;
            }
            case blockLabelRecords.XML.id: {
                component = this.swapTemplates(blockLabelRecords.JSONITEM, blockLabelRecords.XML, mimeType);
                if (this.isMainSceneOrPlayer(mimeType)) {
                    component.template.$.player = blockLabelRecords.XML.id;
                }
                break;
            }
            case blockLabelRecords.STOCKS_ITEM.id: {
                component = blockLabelRecords.STOCKS_ITEM;
                // component = this.swapTemplates(blockLabelRecords.JSONITEM, blockLabelRecords.STOCKS_ITEM, mimeType);
                if (mimeType === SceneMimeTypes.Stocks) {
                    component.template.$.player = blockLabelRecords.STOCKS_ITEM.id;
                }
                break;
            }
            case blockLabelRecords.STOCKS.id: {
                component = this.swapTemplates(blockLabelRecords.JSONITEM, blockLabelRecords.STOCKS, mimeType);
                if (this.isMainSceneOrPlayer(mimeType)) {
                    component.template.$.player = blockLabelRecords.STOCKS.id;
                }
                break;
            }
            case blockLabelRecords.DROPBOX.id: {
                component = this.swapTemplates(blockLabelRecords.JSONITEM, blockLabelRecords.DROPBOX, mimeType);
                break;
            }
            case blockLabelRecords.CALENDAR.id: {
                component = this.swapTemplates(blockLabelRecords.JSONITEM, blockLabelRecords.CALENDAR, mimeType);
                break;
            }
            case blockLabelRecords.WEATHER.id: {
                component = this.swapTemplates(blockLabelRecords.JSONITEM, blockLabelRecords.WEATHER, SceneMimeTypes.Player);
                break;
            }
            case blockLabelRecords.FIVEHUNDRED_COLLECTION.id: {
                component = this.swapTemplates(blockLabelRecords.JSONITEM, blockLabelRecords.FIVEHUNDRED_COLLECTION, mimeType);
                break;
            }
            case blockLabelRecords.FIVEHUNDRED_USER.id: {
                component = this.swapTemplates(blockLabelRecords.JSONITEM, blockLabelRecords.FIVEHUNDRED_USER, mimeType);
                break;
            }
            case blockLabelRecords.ETSY_LIST.id: {
                component = this.swapTemplates(blockLabelRecords.JSONITEM, blockLabelRecords.ETSY_LIST, mimeType);
                break;
            }
            case blockLabelRecords.ETSY_SHOP.id: {
                component = this.swapTemplates(blockLabelRecords.JSONITEM, blockLabelRecords.ETSY_SHOP, mimeType);
                break;
            }
            case blockLabelRecords.ETSY_USER.id: {
                component = this.swapTemplates(blockLabelRecords.JSONITEM, blockLabelRecords.ETSY_USER, mimeType);
                break;
            }
            case blockLabelRecords.FACEBOOK_ALBUM.id: {
                component = this.swapTemplates(blockLabelRecords.JSONITEM, blockLabelRecords.FACEBOOK_ALBUM, mimeType);
                break;
            }
            case blockLabelRecords.FACEBOOK_WALL.id: {
                component = this.swapTemplates(blockLabelRecords.JSONITEM, blockLabelRecords.FACEBOOK_WALL, mimeType);
                break;
            }
            case blockLabelRecords.FACEBOOK_VIDEO.id: {
                component = this.swapTemplates(blockLabelRecords.JSONITEM, blockLabelRecords.FACEBOOK_VIDEO, mimeType);
                break;
            }
            case blockLabelRecords.TUMBLRPHOTOS.id: {
                component = this.swapTemplates(blockLabelRecords.JSONITEM, blockLabelRecords.TUMBLRPHOTOS, mimeType);
                break;
            }
            case blockLabelRecords.TUMBLRPOSTS.id: {
                component = this.swapTemplates(blockLabelRecords.JSONITEM, blockLabelRecords.TUMBLRPOSTS, mimeType);
                break;
            }
            case blockLabelRecords.TUMBLRTEXTS.id: {
                component = this.swapTemplates(blockLabelRecords.JSONITEM, blockLabelRecords.TUMBLRTEXTS, mimeType);
                break;
            }
            case blockLabelRecords.TUMBLRVIDEOS.id: {
                component = this.swapTemplates(blockLabelRecords.JSONITEM, blockLabelRecords.TUMBLRVIDEOS, mimeType);
                break;
            }
            case blockLabelRecords.PINTEREST_BOARD.id: {
                component = this.swapTemplates(blockLabelRecords.JSONITEM, blockLabelRecords.PINTEREST_BOARD, mimeType);
                break;
            }
            case blockLabelRecords.PINTEREST_USER.id: {
                component = this.swapTemplates(blockLabelRecords.JSONITEM, blockLabelRecords.PINTEREST_USER, mimeType);
                break;
            }
            case blockLabelRecords.YELP_INFO.id: {
                component = this.swapTemplates(blockLabelRecords.JSONITEM, blockLabelRecords.YELP_INFO, mimeType);
                break;
            }
            case blockLabelRecords.YELP_REVIEWS.id: {
                component = this.swapTemplates(blockLabelRecords.JSONITEM, blockLabelRecords.YELP_REVIEWS, mimeType);
                break;
            }
            case blockLabelRecords.INSTAGRAM_MEDIA.id: {
                component = this.swapTemplates(blockLabelRecords.JSONITEM, blockLabelRecords.INSTAGRAM_MEDIA, mimeType);
                break;
            }
            case blockLabelRecords.INSTAGRAM_FEED.id: {
                component = this.swapTemplates(blockLabelRecords.JSONITEM, blockLabelRecords.INSTAGRAM_FEED, mimeType);
                break;
            }
            case blockLabelRecords.TWITTER.id: {
                component = this.swapTemplates(blockLabelRecords.JSONITEM, blockLabelRecords.TWITTER, mimeType);
                break;
            }
            case blockLabelRecords.IFTTT.id: {
                component = this.swapTemplates(blockLabelRecords.JSONITEM, blockLabelRecords.IFTTT, mimeType);
                break;
            }
            case blockLabelRecords.FLICKR.id: {
                component = this.swapTemplates(blockLabelRecords.JSONITEM, blockLabelRecords.FLICKR, mimeType);
                break;
            }
            case blockLabelRecords.FACEBOOK_AYRSHARE.id: {
                component = this.swapTemplates(blockLabelRecords.JSONITEM, blockLabelRecords.FACEBOOK_AYRSHARE, mimeType);
                break;
            }
            case blockLabelRecords.FACEBOOK_GROUPS_AYRSHARE.id: {
                component = this.swapTemplates(blockLabelRecords.JSONITEM, blockLabelRecords.FACEBOOK_GROUPS_AYRSHARE, mimeType);
                break;
            }
            case blockLabelRecords.GOOGLE_BUSINESS_AYRSHARE.id: {
                component = this.swapTemplates(blockLabelRecords.JSONITEM, blockLabelRecords.GOOGLE_BUSINESS_AYRSHARE, mimeType);
                break;
            }
            case blockLabelRecords.INSTAGRAM_AYRSHARE.id: {
                component = this.swapTemplates(blockLabelRecords.JSONITEM, blockLabelRecords.INSTAGRAM_AYRSHARE, mimeType);
                break;
            }
            case blockLabelRecords.LINKEDIN_AYRSHARE.id: {
                component = this.swapTemplates(blockLabelRecords.JSONITEM, blockLabelRecords.LINKEDIN_AYRSHARE, mimeType);
                break;
            }
            case blockLabelRecords.PINTEREST_AYRSHARE.id: {
                component = this.swapTemplates(blockLabelRecords.JSONITEM, blockLabelRecords.PINTEREST_AYRSHARE, mimeType);
                break;
            }
            case blockLabelRecords.REDDIT_AYRSHARE.id: {
                component = this.swapTemplates(blockLabelRecords.JSONITEM, blockLabelRecords.REDDIT_AYRSHARE, mimeType);
                break;
            }
            case blockLabelRecords.TELEGRAM_AYRSHARE.id: {
                component = this.swapTemplates(blockLabelRecords.JSONITEM, blockLabelRecords.TELEGRAM_AYRSHARE, mimeType);
                break;
            }
            case blockLabelRecords.TIKTOK_AYRSHARE.id: {
                component = this.swapTemplates(blockLabelRecords.JSONITEM, blockLabelRecords.TIKTOK_AYRSHARE, mimeType);
                break;
            }
            case blockLabelRecords.X_AYRSHARE.id: {
                component = this.swapTemplates(blockLabelRecords.JSONITEM, blockLabelRecords.X_AYRSHARE, mimeType);
                break;
            }
            case blockLabelRecords.YOUTUBE_AYRSHARE.id: {
                component = this.swapTemplates(blockLabelRecords.JSONITEM, blockLabelRecords.YOUTUBE_AYRSHARE, mimeType);
                break;
            }
            case blockLabelRecords.LABEL.id: {
                component = blockLabelRecords.LABEL;
                break;
            }
            case blockLabelRecords.LABELQUEUE.id: {
                component = blockLabelRecords.LABELQUEUE;
                break;
            }
            case blockLabelRecords.FASTERQ.id: {
                component = blockLabelRecords.FASTERQ;
                break;
            }
            case blockLabelRecords.CART.id: {
                component = blockLabelRecords.CART;
                break;
            }
            case blockLabelRecords.KEYBOARD.id: {
                component = blockLabelRecords.KEYBOARD;
                break;
            }
            case blockLabelRecords.HTML.id: {
                component = blockLabelRecords.HTML;
                break;
            }
            case blockLabelRecords.BROWSER.id: {
                component = blockLabelRecords.BROWSER;
                break;
            }
            case blockLabelRecords.LOCATION.id: {
                component = blockLabelRecords.LOCATION;
                break;
            }
            case blockLabelRecords.CAPTURE.id: {
                component = blockLabelRecords.CAPTURE;
                break;
            }
            case blockLabelRecords.BUTTON.id: {
                component = blockLabelRecords.BUTTON;
                break;
            }
            case blockLabelRecords.SWITCH.id: {
                component = blockLabelRecords.SWITCH;
                break;
            }
            case blockLabelRecords.STEPPER.id: {
                component = blockLabelRecords.STEPPER;
                break;
            }
            case blockLabelRecords.ADNET.id: {
                component = blockLabelRecords.ADNET;
                break;
            }
            case blockLabelRecords.FORM.id: {
                component = blockLabelRecords.FORM;
                break;
            }
            case blockLabelRecords.RADIO.id: {
                component = blockLabelRecords.RADIO;
                break;
            }
            case blockLabelRecords.CHECKBOX.id: {
                component = blockLabelRecords.CHECKBOX;
                break;
            }
            case blockLabelRecords.SLIDER.id: {
                component = blockLabelRecords.SLIDER;
                break;
            }
            case blockLabelRecords.INPUT.id: {
                component = blockLabelRecords.INPUT;
                break;
            }
            case blockLabelRecords.EXT_IMAGE.id: {
                component = blockLabelRecords.EXT_IMAGE;
                break;
            }
            case blockLabelRecords.EXT_VIDEO.id: {
                component = blockLabelRecords.EXT_VIDEO;
                break;
            }
            case blockLabelRecords.COUNTDOWN.id: {
                component = blockLabelRecords.COUNTDOWN;
                break;
            }
            case blockLabelRecords.RSS.id: {
                component = blockLabelRecords.RSS;
                break;
            }
            case blockLabelRecords.PODCAST.id: {
                component = blockLabelRecords.PODCAST;
                break;
            }
            case blockLabelRecords.CLOCK.id: {
                component = blockLabelRecords.CLOCK;
                break;
            }
            case blockLabelRecords.IMAGE.id: {
                component = blockLabelRecords.IMAGE;
                break;
            }
            case blockLabelRecords.SVG.id: {
                component = blockLabelRecords.SVG;
                break;
            }
            case blockLabelRecords.PLAYLIST.id: {
                component = blockLabelRecords.PLAYLIST;
                break;
            }
            case blockLabelRecords.MUSICLIST.id: {
                component = blockLabelRecords.MUSICLIST;
                break;
            }
            case blockLabelRecords.MUSIC.id: {
                component = blockLabelRecords.MUSIC;
                break;
            }
            case blockLabelRecords.FLICKING.id: {
                component = blockLabelRecords.FLICKING;
                break;
            }
            case blockLabelRecords.COLLECTION.id: {
                component = blockLabelRecords.COLLECTION;
                break;
            }
            case blockLabelRecords.LOADER.id: {
                component = blockLabelRecords.LOADER;
                break;
            }
            case blockLabelRecords.SCHEDULER.id: {
                component = blockLabelRecords.SCHEDULER;
                break;
            }
            case blockLabelRecords.HOURLYBALANCER.id: {
                component = blockLabelRecords.HOURLYBALANCER;
                break;
            }
            case blockLabelRecords.VIDEO.id: {
                component = blockLabelRecords.VIDEO;
                break;
            }
            case blockLabelRecords.YOUTUBE.id: {
                component = blockLabelRecords.YOUTUBE;
                break;
            }
            case blockLabelRecords.QR.id: {
                component = blockLabelRecords.QR;
                break;
            }
            case blockLabelRecords.CHAT.id: {
                component = blockLabelRecords.CHAT;
                break;
            }
            case blockLabelRecords.WEBCAM.id: {
                component = blockLabelRecords.WEBCAM;
                break;
            }
            case blockLabelRecords.KNX.id: {
                component = blockLabelRecords.KNX;
                break;
            }
            case blockLabelRecords.CANVA.id: {
                component = blockLabelRecords.CANVA;
                break;
            }
            default: {
                component = blockLabelRecords.GENERIC;
                this.toastr.error(this.translocoService.translate('toast.componentNotSupported2', {}, this.translocoService.getActiveLang()));
                if (Lib.DevMode()) {
                    alert('be sure to look at add to scene-add-block-component.ts and search also createComponent(');
                }
            }
        }
        return component;
    }

    onWindowResize() {
        return fromEvent(window, 'resize').pipe(
            debounceTime(333),
            map((e) => {
                return {innerHeight: window.innerHeight, innerWidth: window.innerWidth};
            }));
    }

    listenAllData(): Observable<IAppState> {
        return this.store.select(store => store);
    }

    listenSelectedSceneId(): Observable<string> {
        return this.store.select(store => store.config.uiSceneConfig.selectedSceneId);
    }

    listenSelectedSceneLocationIndex(): Observable<Array<number>> {
        return this.store.select(store => store.config.uiSceneConfig.sceneItemLocationIndexes);
    }

    listenFontsPreviewed(): Observable<Array<string>> {
        return this.store.select(store => store.config.uiSceneConfig.fontsPreviewed);
    }

    listenSelectedSceneLocationCoords(): Observable<Array<number>> {
        return this.store.select(store => store.config.uiSceneConfig.sceneItemLocationCoords);
    }

    listenSelectedScenePlaylist(): Observable<Array<number>> {
        return this.store.select(store => store.config.uiSceneConfig.sceneItemPlaylistIndexes)
            .pipe(filter(v => v !== null));
    }

    listenSelectedSceneItemId(): Observable<string> {
        return this.store.select(store => store.config.uiSceneConfig.selectedSceneItemId);
    }

    listenDuplicateScene(): Observable<IUIDuplicationBlock> {
        return this.store.select(store => store.config.uiSceneConfig.lastDuplication);
    }

    listenDuplicateSceneCommand(): Observable<DuplicateCommand> {
        return this.store.select(store => store.config.uiSceneConfig.lastDuplicationCommand);
    }

    listenSceneAnimationClipboard(): Observable<IAnimationEngine> {
        return this.store.select(store => store.config.uiSceneConfig.sceneAnimationClipboard);
    }

    listenSelectedSceneIdAndSceneItemId(alwaysReturn = false): Observable<ISelectedSceneSceneId> {
        const selectedSceneId$ = this.store.select(store => store.config.uiSceneConfig.selectedSceneId);
        const selectedSceneItemId$ = this.store.select(store => store.config.uiSceneConfig.selectedSceneItemId);
        return combineLatest([selectedSceneItemId$, selectedSceneId$]).pipe(
            map(([sceneItemId, sceneId]) => {
                if (isNoValue(sceneItemId) || isNoValue(sceneId))
                    if (alwaysReturn) {
                        return {
                            sceneId: null,
                            sceneItemId: null
                        };
                    } else {
                        return null;
                    }
                return {
                    sceneId,
                    sceneItemId
                };
            }),
            filter(value => value !== null)
        );
    }

    listenSelectedScene() {
        const selectedSceneId$ = this.store.select(store => store.config.uiSceneConfig.selectedSceneId);
        const scenes$ = this.store.select(store => store.users.scenes);
        return combineLatest([selectedSceneId$, scenes$]).pipe(
            map(([sceneId, i_scenes]) => {
                if (!_.isNull(i_scenes)) {
                    return i_scenes.find((i_scene: IPlayerProps) => i_scene.Player.$.id === sceneId);
                }
                return null;
            })
        );
    }

    listenPlayerDataOfSelectedSceneItemId(alwaysReturn = false): Observable<ISceneTreeSliceResults> {
        const selectedSceneId$ = this.store.select(store => store.config.uiSceneConfig.selectedSceneId);
        const selectedSceneItemId$ = this.store.select(store => store.config.uiSceneConfig.selectedSceneItemId);
        const scenes$ = this.store.select(store => store.users.scenes);
        return combineLatest([selectedSceneItemId$, selectedSceneId$, scenes$]).pipe(
            map(([sceneItemId, sceneId, scenes]) => {
                if (isNoValue(sceneItemId) || isNoValue(sceneId) || isNoValue(scenes))
                    if (alwaysReturn) {
                        return {sceneId: null, sceneItem: null};
                    } else {
                        return null;
                    }
                return getPlayerIdInScene(scenes, sceneId, sceneItemId);
            }),
            filter(value => value !== null)
        );
    }

    public listenScenes(): Observable<IPlayerProps[]> {
        return this.store.select(store => store.users.scenes)
            .pipe(filter((scenes) => !_.isUndefined(scenes) && !_.isNull(scenes)));
    }

    public listenSceneImports(): Observable<ISceneTemplateImport[]> {
        return this.store.select(store => store.users.sceneTemplateImports)
            .pipe(filter((scenes) => !_.isNull(scenes)));
    }

    public listenPlayersOfScene(i_selectedSceneId): Observable<ISceneBlock[]> {
        return this.store.select(store => store.users.scenes).pipe(
            filter((i_scenes: IPlayerProps[]) => !_.isNull(i_scenes)),
            map((i_scenes: IPlayerProps[]) => {
                return i_scenes.find((i_scene: IPlayerProps) => {
                    return i_scene.Player.$.id == i_selectedSceneId;
                });
            }),
            map((i_scenePlayer: IPlayerProps) => {
                return (i_scenePlayer ? (i_scenePlayer.Player.Data["0"].Scene["0"].Players["0"].Player) : []) as ISceneBlock[];
            }));
    }

    public listenPrivateChildPlayersOfScene(i_selectedSceneId): Observable<ISceneBlock[]> {
        return this.store.select(store => store.users.scenes).pipe(
            filter((i_scenes: IPlayerProps[]) => !_.isNull(i_scenes)),
            map((i_scenes: IPlayerProps[]) => {
                return i_scenes.find((i_scene: IPlayerProps) => {
                    return i_scene.Player.$.id == i_selectedSceneId;
                });
            }),
            map((i_scenePlayer: IPlayerProps) => {
                const players = (i_scenePlayer ? (i_scenePlayer.Player.Data["0"].Scene["0"].Players["0"].Player) : []);
                if (!players) return [];
                return players.filter((i_player) => `${i_player.$.private_child}` === 'true') as ISceneBlock[];
            }));
    }

    public listenSceneData(i_selectedSceneId): Observable<IPlayerProps> {
        return this.store.select(store => store.users.scenes).pipe(
            filter((i_scenes: IPlayerProps[]) => !_.isNull(i_scenes)),
            map((i_scenes: IPlayerProps[]) => {
                return i_scenes.find((i_scene: IPlayerProps) => {
                    return i_scene.Player.$.id === i_selectedSceneId;
                });
            }));
    }

    public listenSceneOptions(): Observable<any> {
        return this.store.select(store => store.users.scenes)
            .pipe(
                filter((scenes) => !_.isUndefined(scenes) && !_.isNull(scenes)),
                map((i_scenes) => {
                    return i_scenes.map((i_scene: IPlayerProps) => ({
                        id: i_scene.Player.$.id,
                        label: i_scene.Player.$.label,
                        mimeType: i_scene.Player.$.mimeType
                    }));
                })
            );
    }

    /** For now, we do not use this function. Because, touch components can be layered at any position */
    public getPlayerIndexByTouch(i_selectedSceneId): Observable<number> {
        return this.store.select(store => store.users.scenes).pipe(
            filter((i_scenes: IPlayerProps[]) => !_.isNull(i_scenes)),
            map((i_scenes: IPlayerProps[]) => {
                return i_scenes.find((i_scene: IPlayerProps) => {
                    return i_scene.Player.$.id === i_selectedSceneId;
                });
            }),
            map((i_scenePlayer: IPlayerProps) => {
                if (!i_scenePlayer) return -1;
                if (!i_scenePlayer.Player.Data["0"]?.Scene["0"]?.Players["0"]?.Player) {
                    return -1;
                }
                return i_scenePlayer.Player.Data["0"].Scene["0"].Players["0"].Player.findIndex((_player) => {
                    /** 04-03-2022 ran into rare cases where no $ existed so just return false as this is not touch component **/
                    if (!_player.$) return false;
                    return this.getBlockLabelById(_player.$.player).touch;
                });
            }));
    }

    public getState<T>(slice, emitOnEmpty = true): Promise<List<T>> {
        let go = 1;
        return new Promise((res, err) => {
            this.store.select(store => store.adnet[slice])
                .pipe(
                    filter((v) => v !== null),
                    takeWhile((v) => go > 0)
                )
                .subscribe((d: List<T>) => {
                    go = 0;
                    if (emitOnEmpty === false && d.size === 0) return;
                    res(d);
                });
        });
    }

    public getLiveChatStatusV1(): Observable<number> {
        return this.store.select(store => store.config.chat.liveStatus);
    }

    public getLiveChatStatusV2(): Observable<IChatGlobal> {
        return this.store.select(store => store.config.chat);
    }

    public getPreloginResellerInfo(): Observable<IPreloadResellerInfo> {
        return this.store.select(store => store.users.preLoginResellerInfo)
            .pipe(filter((reseller) => reseller !== null));
    }

    public getAdnetCustomerCredentialsPromise(i_customerId: string): Promise<IAdnetCustomerCredentials> {
        let go = 1;
        return new Promise((res, err) => {
            return this.getEnterpriseBusinesses()
                .pipe(take(1),
                    map((b) => {
                        // tslint:disable-next-line:no-shadowed-variable
                        const res = b.Businesses.BusinessInfo.find((v) => {
                            return v.AdNet[0].$.customerId == i_customerId;
                        });
                        return {
                            adnetCustomerId: i_customerId,
                            adnetTokenId: res.AdNet[0].$.customerToken,
                            businessId: res.$.businessId
                        };
                    }),
                    takeWhile((v) => go > 0))
                .subscribe((d: IAdnetCustomerCredentials) => {
                    go = 0;
                    res(d);
                });
        });
    }

    public getAdnetCustomerCredentials(i_customerId: string): Observable<IAdnetCustomerCredentials> {
        return this.getEnterpriseBusinesses()
            .pipe(take(1), map((b) => {
                const res = b.Businesses.BusinessInfo.find((v) => {
                    return v.AdNet[0].$.customerId == i_customerId;
                });
                return {
                    adnetCustomerId: i_customerId,
                    adnetTokenId: res.AdNet[0].$.customerToken,
                    businessId: res.$.businessId
                };
            }));
    }

    public getAdnet(): Observable<IAdnetState> {
        return this.store.select(store => store.adnet);
    }

    public getAdnetRates(): Observable<List<AdnetRateModel>> {
        return this.store.select(store => store.adnet.rates);
    }

    public getAdnetPairs(): Observable<List<AdnetPairModel>> {
        return this.store.select(store => store.adnet.pairs).pipe(filter((user) => user !== null));
    }

    public getAdnetTransfers(): Observable<List<AdnetTransferModel>> {
        return this.store.select(store => store.adnet.transfers).pipe(filter((user) => user !== null));
    }

    public getAdnetPayments(): Observable<List<AdnetPaymentModel>> {
        return this.store.select(store => store.adnet.payments).pipe(filter((user) => user !== null));
    }

    public getAdnetReports(): Observable<List<AdnetReportModel>> {
        return this.store.select(store => store.adnet.reports).pipe(filter((user) => user !== null));
    }

    public getAdnetPackages(): Observable<List<AdnetPackageModel>> {
        return this.store.select(store => store.adnet.packages).pipe(filter((user) => user !== null));
    }

    public getAdnetTargets(): Observable<List<AdnetTargetModel>> {
        return this.store.select(store => store.adnet.targets).pipe(filter((user) => user !== null));
    }

    public getAdnetTargetsSearch(): Observable<List<AdnetTargetModel>> {
        return this.store.select(store => store.adnet.targets_search).pipe(filter((user) => user !== null));
    }

    public getAdnetCustomersNoFilter(): Observable<List<AdnetCustomerModel>> {
        return this.store.select(store => store.adnet.customers);
    }

    public getAdnetCustomers(): Observable<List<AdnetCustomerModel>> {
        return this.store.select(store => store.adnet.customers).pipe(filter((user) => user !== null));
    }

    public getLoginViewMode(): Observable<EnumLoginViewMode> {
        return this.store.select(store => store.config.appSettings.loginState);
    }

    public getOS(): Observable<IOS> {
        return this.store.select(store => store.config.os);
    }

    public isFirefox(): Observable<boolean> {
        return this.getOS()
            .pipe(map((os) => {
                    return os?.name1?.toLowerCase()?.indexOf('firefox') > -1 || os?.name2?.toLowerCase()?.indexOf('firefox') > -1;
                })
            );
    }

    public getLockedRecords(): Observable<ILockedRecord> {
        return this.store.select(store => store.users.lockedRecord);
    }

    public getChangelistIds(): Observable<IChangeListIds> {
        const changelistIdSocket$ = this.store.select(store => store.users.lockedRecord);
        const changelistIdSync$ = this.store.select(store => store.users.changelistId);
        return combineLatest([changelistIdSocket$, changelistIdSync$]).pipe(
            map(([a, b]) => {
                return {
                    changelistIdSync: a?.changelistId ? a.changelistId : NONE_VALUE,
                    changelistIdSocket: b ? b : NONE_VALUE
                };
            })
        );
    }

    // public getChangelistSocketId(): Observable<number> {
    //     return this.store.select(store => store.users.changelistId).pipe(map((v) => {
    //         if (isNullOrUndef(v)) return NONE_VALUE;
    //         return v;
    //     }));
    // }

    public getUser(emitOnEmpty?): Observable<IUser> {
        return this.store.select(store => store.users.selectedUser)
            .pipe(filter((user) => {
                    if (emitOnEmpty) return true;
                    return user !== null;
                })
            );
    }

    public getUserAccountDetails(): Observable<IAccountDetails> {
        if (this.m_user?.dashboard) {
            return this.getEnterpriseAccDetails();
        } else {
            return this.getUserAccDetail();
        }
    }

    public getUserAccDetail(): Observable<IAccountDetails> {
        return this.store.select(store => store.users.userDetails).pipe(filter((data) => data !== null));
    }

    public getEnterpriseAccDetails(): Observable<IAccountDetails> {
        return this.store.select(store => store.enterprise.enterpriseAccount).pipe(filter((data) => data !== null));
    }

    public getStorageStatistics(): Observable<IResourceStatistic> {
        const resourceTypes = SUPPORTED_FILE_TYPES;
        return this.getResources().pipe(
            map((i_resource) => {
                let categories: Array<string> = [];
                const resourcesByType = {};
                resourceTypes.forEach((type) => {
                    resourcesByType[type] = 0;
                });
                let totalSize = 0;
                i_resource.forEach((s, idx) => {
                    if (s.tree_path) {
                        categories.push(s.tree_path);
                    }
                    totalSize += parseInt(s.resource_bytes_total, 0);
                    const res_type = s.resource_type.toLowerCase();

                    switch (res_type) {
                        case "flv": {
                            resourcesByType['flv']++;
                            break;
                        }
                        case "m4v": {
                            resourcesByType['m4v']++;
                            break;
                        }
                        case "mp4": {
                            resourcesByType['mp4']++;
                            break;
                        }
                        case "jpeg":
                        case "jpg": {
                            resourcesByType['jpg']++;
                            break;
                        }
                        case "png": {
                            resourcesByType['png']++;
                            break;
                        }
                        case "gif": {
                            resourcesByType['gif']++;
                            break;
                        }
                        case "svg": {
                            resourcesByType['svg']++;
                            break;
                        }
                        case "swf": {
                            resourcesByType['swf']++;
                            break;
                        }
                        default: {
                            resourcesByType['other']++;
                            break;
                        }
                    }
                });
                categories = categories
                    .reduce((x, y) => x.includes(y) ? x : [...x, y], [])
                    .sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
                const resourceStatistics = Array.from(resourceTypes, key => ({
                    name: key,
                    value: resourcesByType[key]
                }));
                const dataStorageUsed = [
                    {
                        name: "used storage",
                        value: formatBytes(totalSize, 2)
                    }
                ];
                const dataStoragePercent = [
                    {
                        name: "free cloud storage",
                        value: 1024 * 1024 - Math.round(totalSize)
                    },
                    {
                        name: "used storage",
                        value: Math.round(totalSize)
                    }
                ];
                return {resourceStatistics, dataStoragePercent, dataStorageUsed, categories, resourcesByType};
            }), filter((v) => {
                return v.dataStorageUsed?.[0]?.value !== '0 Byte';
            })
        );
    }

    public getResourceSharedLibrary(): Observable<ISharedResourceLibrary> {
        return this.store.select(store => store.users.resourceSharedLibrary)
            .pipe(
                filter((data) => data !== null)
            );
    }

    public getLocalStoreUpdates(filterBy?: ILocalStoreTypes): Observable<ILocalStorageUpdates> {
        return this.store.select(store => store.config.localStorageUpdates).pipe(filter((v) => {
            if (!filterBy) return true;
            if (!v) return true;
            return v?.latestEvent === filterBy;
        }));
    }

    public getCreateEnterprise(): Observable<ILoginForm> {
        return this.store.select(store => store.users.createCredentials).pipe(map((v) => ({
            username: v?.username ? v.username : '',
            password: v?.password ? v.password : ''
        })));
    }

    public getSocialUserServerReply(): Observable<ISocialServerReply> {
        return this.store.select(store => store.config.socialUserServerReply).pipe(filter((user) => user !== null));
    }

    public getSocialUser(emitOnEmpty: boolean = false): Observable<{ a: SocialUser, b: ISocialServerReply }> {
        const socialUser$ = this.store.select(store => store.config.socialUser);
        const socialUserServerReply$ = this.store.select(store => store.config.socialUserServerReply);
        return combineLatest([socialUser$, socialUserServerReply$]).pipe(
            map(([a, b]) => ({a, b})),
            mergeMap(v => (v ? of(v) : (emitOnEmpty ? of(v) : empty())))
        );
    }

    public getResellerId(i_localStore: LocalStoreService): Observable<number> {
        const resellerStaticId$ = this.store.select(store => store.config?.staticIndexHTML?.resellerStaticId);
        const resellerId$ = this.store.select(store => store.users.selectedUser?.resellerId);
        const localStoreUpdates$ = this.getLocalStoreUpdates('ILocalStorageConfig');
        return combineLatest([resellerStaticId$, resellerId$, localStoreUpdates$])
            .pipe(
                map(([resellerStaticId, resellerId, localStoreUpdates]) => {
                    if (localStoreUpdates) {
                        const isWhitelabel = i_localStore.getStorageValConfig('isWhitelabel');
                        if (isDigitNoEmpty(isWhitelabel) && isWhitelabel !== '0') {
                            return Number(isWhitelabel);
                        }
                    }
                    if (isDigitNoEmpty(resellerStaticId))
                        return Number(resellerStaticId);
                    if (isDigitNoEmpty(Number(resellerId)))
                        return Number(resellerId);
                    return DEFAULT_RESELLER_ID;
                }),
                distinctUntilChanged()
            );
    }

    public getLocalStatic(): Observable<string> {
        return this.store.select(store => store.config?.staticIndexHTML.language);
    }

    public getEnterpriseReseller(): Observable<IEnterpriseReseller> {
        return this.store.select(store => store.enterprise.enterpriseReseller).pipe(filter((data) => data !== null));
    }

    public getEnterpriseApps(): Observable<Array<IStoreApps>> {
        return this.store.select(store => store.enterprise.enterpriseReseller).pipe(
            filter((data) => data !== null),
            map((v) => v.User.BusinessInfo[0].Apps));
    }

    public getEnterpriseWhiteLabel(): Observable<Array<IWhiteLabel>> {
        return this.store.select(store => store.enterprise.enterpriseReseller).pipe(
            filter((data) => data !== null),
            map((v) => v.User.BusinessInfo[0].WhiteLabel));
    }

    public getEnterpriseThemes(): Observable<Array<any>> {
        return this.store.select(store => store.enterprise.enterpriseReseller).pipe(
            filter((data) => data !== null),
            map((v) => v.User.BusinessInfo[0].Themes));
    }

    public getEnterpriseInstalledApps(): Observable<Array<IInstalledApp>> {
        return this.store.select(store => store.enterprise.enterpriseReseller).pipe(
            filter((data) => data !== null),
            map((v) => v.User.BusinessInfo[0].InstalledApps));
    }

    public getOrder(): Observable<IOrderDetails> {
        return this.store.select(store => store.users.order).pipe(filter((data) => data !== null));
    }

    public getOrders(): Observable<Array<IOrderForm>> {
        return this.store.select(store => store.users.orders).pipe(filter((data) => data !== null));
    }

    public getDomainBusinesses(): Observable<Array<string>> {
        const domains = [];
        return this.store.select(store => store.enterprise.enterpriseBusiness).pipe(map((v) => {
            v.Businesses.BusinessInfo.forEach((b: IBusinessAccount) => {
                if (domains.indexOf(b.$.domain) === -1) {
                    domains.push(b.$.domain);
                }
            });
            return domains;
        }));
    }

    public getBusinessesByDomain(): Observable<IBusinessDomainCollection> {
        const domains = {};
        return this.store.select(store => store.enterprise.enterpriseBusiness).pipe(map((v) => {
            if (v) {
                if (isNullOrUndefOrEmpty(v.Businesses.BusinessInfo)) {
                    return [];
                }
                v.Businesses.BusinessInfo.forEach((b: IBusinessAccount) => {
                    const domain = b.$.domain;
                    if (!domains[domain]) domains[domain] = [];
                    domains[domain].push(b.$.businessId);
                });
            }
            return domains;
        }));
    }

    public getEventParams(): Observable<Array<IEventParam>> {
        return this.store.select(appStore => appStore.users.eventParams).pipe(
            filter(data => data != null),
            map((v) => v)
        );
    }

    public getEventStrings(): Observable<Array<string>> {
        return this.store.select(appStore => appStore.users.eventsStrings).pipe(
            filter(data => data != null),
            map((v) => v)
        );
    }

    public getEventBlocks(): Observable<Array<IEventBlock>> {
        return this.store.select(appStore => appStore.users.eventBlocks).pipe(
            filter(data => data != null),
            map((v) => v)
        );
    }

    public getEmpty(): Observable<Array<string>> {
        return of[''];
    }

    public getEventsCombined(): Observable<Array<string>> {
        const eventsStrings$ = this.store.select(store => store.users.eventsStrings);
        const eventParams$ = this.store.select(store => store.users.eventParams);
        return combineLatest([eventsStrings$, eventParams$]).pipe(
            map(([a, b]) => {
                const z = [];
                b.forEach((c) => {
                    z.push(c.event_name);
                });
                return [...new Set([...a, ...z])];
            })
        );
    }

    public getDynawebsOrder(): Observable<IOrderForm> {
        return this.store.select(appStore => appStore.users.dynawebs.order).pipe(filter(data => data != null));
    }

    public getDynawebsServer(): Observable<IDynawebsServerReply> {
        return this.store.select(appStore => appStore.users.dynawebs.dynawebsServer).pipe(filter(data => data != null));
    }

    public getDynawebsCart(): Observable<ICart> {
        return this.store.select(appStore => appStore.users.dynawebs.cart).pipe(filter(data => data != null));
    }

    public getDynawebsCartProducts(): Observable<Array<ICartProduct>> {
        return this.store.select(appStore => appStore.users.dynawebs.products).pipe(filter(data => data != null));
    }

    public getCartProducts(): Observable<Array<ICartProduct>> {
        return this.store.select(appStore => appStore.users.cart.products).pipe(filter(data => data != null));
    }

    public getCartProduct(name): Observable<ICartProduct> {
        return this.getCartProducts().pipe(map(v => {
            return v.find((b) => {
                return b.name === name;
            });
        }));
    }

    public getCartContents(): Observable<Array<ICartProduct>> {
        return this.store.select(appStore => appStore.users.cart.cartContent).pipe(filter(data => data != null));
    }

    public getCart(): Observable<ICart> {
        return this.store.select(appStore => appStore.users.cart).pipe(filter(data => data != null));
    }

    public getEnterpriseData(): Observable<object> {
        const enterpriseBusinessUsers$ = this.store.select(store => store.enterprise.enterpriseBusinessUsers);
        const enterpriseBusiness$ = this.store.select(store => store.enterprise.enterpriseBusiness);
        const enterpriseReseller$ = this.store.select(store => store.enterprise.enterpriseReseller);
        return combineLatest([enterpriseBusiness$, enterpriseReseller$, enterpriseBusinessUsers$]).pipe(
            map(([a, b, c]) => {
                if (isNullOrUndefOrEmpty(c))
                    c = [] as any;
                return {a, b, c};
            }),
            filter((values: any) => {
                return values.a && values.b && values.c;
            })
        );
    }


    public getEnterpriseAccountsList(): Observable<List<BusinessModel>> {
        const businesses = [];
        return this.store.select(store => store.enterprise.enterpriseBusiness).pipe(map(b => {
            b.Businesses.BusinessInfo.forEach((i_business) => {
                const business: BusinessModel = new BusinessModel({
                    businessId: i_business.$.businessId,
                    source: i_business.$.domain,
                    name: i_business.$.name,
                    accountStatus: i_business.$.accountStatus,
                    applicationId: i_business.$.applicationId,
                    archiveState: i_business.$.archiveState,
                    fromTemplateId: i_business.$.fromTemplateId,
                    maxMonitors: i_business.$.maxMonitors,
                    maxDataStorage: i_business.$.maxDataStorage,
                    allowSharing: i_business.$.allowSharing,
                    studioLite: i_business.$.studioLite,
                    lastLogin: i_business.$.lastLogin,
                    resellerId: i_business.$.resellerId,
                    businessDescription: i_business.$.businessDescription,
                    adnetToken: i_business.AdNet["0"].$.customerToken,
                    adnetCustomerId: i_business.AdNet["0"].$.customerId
                });
                businesses.push(business);
            });
            return List<any>(businesses);
        }));
    }

    public getEnterprisePrivileges(): Observable<Array<IPrivileges>> {
        return this.store.select(store => store.enterprise.enterpriseReseller)
            .pipe(
                filter((data) => data !== null),
                map((v) => {
                    return v.User.BusinessInfo[0].Privileges[0].Privilege;
                })
            );
    }

    public getEnterpriseBusinesses(): Observable<IEnterpriseBusinesses> {
        return this.store.select(store => store.enterprise.enterpriseBusiness).pipe(filter((data) => data !== null));
    }

    public getEnterpriseBusinessUsers(): Observable<IEnterpriseBusinessUsers> {
        return this.store.select(store => store.enterprise.enterpriseBusinessUsers).pipe(filter((data) => data !== null));
    }

    public getAppSettings(): Observable<IAppStatic> {
        return this.store.select(store => store.config.appSettings);
    }

    // public getStationTracking(): Observable<IStationTrackReply[]> {
    //     if (this.m_user?.dashboard) {
    //         return this.store.select(appStore => appStore.enterprise.enterpriseStationTrack);
    //     } else {
    //         return this.store.select(appStore => appStore.users.userStationTrack);
    //     }
    // }

    // public getTrackStats(): Observable<IStationTrackReply[]> {
    //     // return combineLatest([this.getUser(), this.listenAllData()]).pipe(map(([a, b]) => {
    //     //     if (a.dashboard) {
    //     //         return b.enterprise.enterpriseStationTrackStats;
    //     //     } else {
    //     //         return b.users.userStationTrackStats;
    //     //     }
    //     // }))
    //     if (this.m_user?.dashboard) {
    //         return this.store.select(appStore => appStore.enterprise.enterpriseStationTrackStats).pipe(
    //             filter((data) => data !== null)
    //         );
    //     } else {
    //         return this.store.select(appStore => appStore.users.userStationTrackStats).pipe(
    //             filter((data) => data !== null)
    //         );
    //     }
    // }

    // public getEnterpriseTrackState(): Observable<IStationTrackReply[]> {
    //     return this.store.select((state) => state.enterprise.enterpriseStationTrackStats).pipe(filter((data) => data !== null));
    // }

    public getCoreData(): Observable<IAppSettingsWrap> {
        return combineLatest([this.getUser(), this.getAppSettings()]).pipe(map(([a, b]) => {
            return [a, b];
        }));
    }

    public getTransitionItems(): Observable<Array<ITransitionPoolItem>> {
        return this.store.select(appStore => appStore.users.transitionPoolItems).pipe(
            filter(data => data != null),
            map((v) => v)
        );
    }

    public getTransitionPools(): Observable<Array<ITransitionPool>> {
        return this.store.select(appStore => appStore.users.transitionPools).pipe(
            filter(data => data != null),
            map((v) => v)
        );
    }

    public getMusicSongs(): Observable<Array<IMusicChannelSong>> {
        return this.store.select(appStore => appStore.users.musicChannelSongs).pipe(
            filter(data => data != null),
            map((v) => v)
        );
    }

    public getMusicChannels(): Observable<Array<IMusicChannel>> {
        return this.store.select(appStore => appStore.users.musicChannels).pipe(
            filter(data => data != null),
            map((v) => v)
        );
    }

    public getScheduleEvents(): Observable<Array<IScheduleEvent>> {
        return this.store.select(appStore => appStore.users.scheduleEvents).pipe(
            filter(data => data != null),
            map((v) => v)
        );
    }

    public getScheduleEventsBySchedule(schedule_id): Observable<Array<IScheduleEvent>> {
        return this.store.select(appStore => appStore.users.scheduleEvents).pipe(
            filter(data => data != null),
            map((v) => {
                return v.filter((e) => e.schedule_id === schedule_id);
            })
        );
    }

    public getScheduleEventsBySource(event_source: 'scene' | 'resource', sourceIds: Array<Id>): Observable<Array<IScheduleEvent>> {
        return this.store.select(appStore => appStore.users.scheduleEvents).pipe(
            filter(data => data != null),
            map((v) => {
                return v.filter((e) => {
                    const eventValue = e.event_value ? JSON.parse(e.event_value) : {};
                    return eventValue.type === event_source && sourceIds.includes(String(eventValue.id));
                });
            })
        );
    }

    public getSchedules(): Observable<Array<ISchedule>> {
        return this.store.select(appStore => appStore.users.schedules).pipe(
            filter(data => data != null),
            map((v) => v)
        );
    }

    public getSelectedSchedule(): Observable<ISchedule> {
        const selectedId$ = this.store.select(store => store.config.scheduleSelectionState.scheduler);
        const schedules$ = this.store.select(store => store.users.schedules);
        return combineLatest([selectedId$, schedules$]).pipe(
            map(([schedule, i_schedules]) => {
                if (!_.isNull(i_schedules)) {
                    return i_schedules.find((i_schedule: ISchedule) => i_schedule.schedule_id === schedule.scheduleId);
                }
                return null;
            })
        );
    }

    /** if filterByKey return if any found matches, otherwise return entire global settings if one exists **/
    public getGlobalSettings(filterByKey?: IGlobalSettingKey): Observable<IGlobalSettings[]> {
        return this.store.select(appStore => appStore.users.globalSettings)
            .pipe(
                filter((data) => !(isNullOrUndefined(data) || data.length === 0)),
                map((v) => {
                    return v.filter((d) => {
                        if (!filterByKey) return true;
                        return d?.param_key === filterByKey;
                    });
                }),
                filter((data) => {
                    return data && data.length > 0;
                })
            );
    }

    public getPreviousLinkedScene(): Observable<string> {
        return this.store.select(appStore => appStore.users.previousLinkedSceneId).pipe(
            filter(data => data != null),
            map((v) => v)
        );
    }

    public listenSelectedSchedule(): Observable<IScheduleSelection> {
        return this.store.select(store => store.config.scheduleSelectionState);
    }

    public getCatalogItems(): Observable<Array<ICatalogItems>> {
        return this.store.select(appStore => appStore.users.catalogItems).pipe(
            filter(data => data != null),
            map((v) => v)
        );
    }

    public getCatalogItemCategories(): Observable<Array<ICatalogItemCategories>> {
        return this.store.select(appStore => appStore.users.catalogItemCategories).pipe(
            filter(data => data != null),
            map((v) => v)
        );
    }

    public getCatalogValues(): Observable<Array<ICategoryValues>> {
        return this.store.select(appStore => appStore.users.categoryValues).pipe(
            filter(data => data != null),
            map((v) => v)
        );
    }

    public getCatalogResources(): Observable<Array<ICatalogItemResources>> {
        return this.store.select(appStore => appStore.users.catalogItemResources).pipe(
            filter(data => data != null),
            map((v) => v)
        );
    }

    public getCatalogInfos(): Observable<Array<ICatalogItemInfos>> {
        return this.store.select(appStore => appStore.users.catalogItemInfos).pipe(
            filter(data => data != null),
            map((v) => v)
        );
    }

    public getResource(i_resourceId): Observable<IResource> {
        return this.store.select(appStore => appStore.users.resources)
            .pipe(
                filter(data => data != null),
                map((v) => {
                    return v[v.findIndex((a) => a.resource_id == i_resourceId)];
                })
            );
    }

    // public async crudRecord(saveRecord: ICRUDRecord): Promise<ICRUDRecord> {
    //     return new Promise((res, err) => {
    //         this.userService.crudRecord(saveRecord)
    //             .pipe(
    //                 map((i_reply: ICRUDRecordReply) => {
    //                     saveRecord.command = "reply";
    //                     saveRecord.serverReply = i_reply;
    //                     return res(saveRecord);
    //                 }),
    //                 catchError((i_error) => {
    //                     console.log(`actionCRUDRecordFailure ${i_error.message}`);
    //                     saveRecord.command = "reply";
    //                     saveRecord.serverReply = {id: null, status: false};
    //                     err(saveRecord);
    //                     return of(actionCRUDRecordFailure({saveRecord: {studioId: null, command: "reply", body: i_error, serverReply: {status: false, id: null}}}));
    //                 })
    //             ).subscribe();
    //     });
    // }


    public async getResourceById(i_resourceId): Promise<IResource> {
        return new Promise((res, err) => {
            this.store.select(appStore => appStore.users.resources)
                .pipe(
                    filter(data => data != null),
                    map((v) => {
                        return v[v.findIndex((a) => a.resource_id == i_resourceId)];
                    })
                )
                .subscribe((v: IResource) => {
                    return res(v);
                });
        });
    }

    public getResources(skipZeroSize = true): Observable<IResource[]> {
        return this.store.select(appStore => appStore.users.resources)
            .pipe(
                filter((data) => data !== null),
                map((v) => {
                    if (skipZeroSize === false) return v;
                    return v.filter((c: IResource) => {
                        return !(c?.resource_bytes_total === '0' && c?.resource_name?.length === 0);
                    });
                    // if (c?.resource_bytes_total === '0' && c?.resource_name?.length === 0) {
                    //     Lib.DevShow('>>>>>>>> skipping invalid resource: ' + c?.resource_id);
                    //     return false;
                    // }
                })
            );
    }

    // public getResources(): Observable<IResource[]> {
    //     return this.store.select(appStore => appStore.users.resources)
    //         .pipe(filter((data) => data !== null));
    // }

    public listenResourceById(i_resourceId): Observable<IResource> {
        return this.store.select(appStore => appStore.users.resources)
            .pipe(
                filter(data => data != null),
                map((v) => {
                    return v[v.findIndex((a) => a.resource_id == i_resourceId)];
                })
            );
    }

    // public getPrivileges(): Observable<IPrivileges[]> {
    //     return this.store.select(appStore => appStore.enterprise.enterpriseReseller.User.BusinessInfo[0].Privileges)
    //         .map(v => v);
    // }

    public getScenes(i_removeProblemScenes: boolean = false, includePrivateChild: boolean = false, onlyPrivateChild: boolean = false): Observable<IPlayerProps[]> {
        return this.store.select(appStore => appStore.users.scenes).pipe(
            filter(data => data != null),
            map(data => {
                if (onlyPrivateChild) {
                    return data.filter((v) => {
                        return `${v.Player.$.private_child}` === 'true'; /** if private_child does exist but valued at false, also include it in array **/
                    });
                }
                if (includePrivateChild) {
                    return data;
                }
                return data.filter((v) => {
                    return !v.Player.$.private_child || `${v.Player.$.private_child}` !== 'true'; /** if private_child does exist but valued at false, also include it in array **/
                });
            }),
            map(data => {
                if (!i_removeProblemScenes) return data;
                return data.filter((v) => {
                    if (isSceneDesktopEmpty(v)) return false;
                    return !isSceneEmbedded(v);
                });
            }));
    }

    public getLastGetTime(): Observable<number> {
        return this.store.select(appStore => appStore.users.lastGetTime).pipe(
            filter(data => data != null),
            map(v => v));
    }


    public getSceneMimeType(i_sceneId): Observable<string> {
        return this.store.select(appStore => appStore.users.scenes)
            .pipe(
                take(1),
                filter((data) => data !== null),
                map((a) => {
                    const scene = a[a.findIndex((i_scene) => i_scene.Player.$.id == i_sceneId)];
                    return scene.Player.$.mimeType;
                })
            );
    }

    public getScene(i_sceneId): Observable<IPlayerProps> {
        return this.store.select(appStore => appStore.users.scenes).pipe(
            filter(data => data != null),
            map((v) => {
                return v[v.findIndex((i_scene) => i_scene.Player.$.id == i_sceneId)];
            })
        );
    }

    public isFullFeatures(): Observable<boolean> {
        return this.store.select(appStore => appStore.config.appSettings.isFullFeatures);
    }

    public getSceneMime(i_sceneId): Observable<string> {
        return this.store.select(appStore => appStore.users.scenes).pipe(
            take(1),
            filter((data) => data !== null),
            map((v) => {
                const scene = v[v.findIndex((i_scene) => i_scene.Player.$.id == i_sceneId)];
                return scene.Player.$.mimeType;
            })
        );
    }

    public getStationStats(): Observable<IStationStatsV1[]> {
        if (this.m_user && this.m_user.dashboard) {
            return this.store.select(appStore => appStore.enterprise.enterpriseStations).pipe(
                filter((data) => data !== null)
                // ,mergeMap(a => a)
            );
        } else {
            return this.store.select(appStore => appStore.users.stationStats)
                .pipe(
                    filter((data) => {
                        return data !== null;
                    }),
                    map((data) => {
                        return data;
                    })
                    // ,mergeMap(a => a)
                );
        }
    }

    public getStation(businessStationId): Observable<IStation> {
        return this.store.select(appStore => appStore.users.stations)
            .pipe(map((v) => {
                    return v.find((d) => {
                        return d.station_business_id === businessStationId;
                    });
                })
            );
    }

    public getStations(emitOnEmpty?): Observable<IStation[]> {
        return this.store.select(appStore => appStore.users.stations)
            .pipe(map(v => v),
                filter(v => {
                    if (emitOnEmpty) return true;
                    return v !== null;
                })
            );
    }

    public getEnterpriseStations(): Observable<IStationStatsV1[]> {
        return this.store.select(appStore => appStore.enterprise.enterpriseStations)
            .pipe(
                map(v => v ? v : [])
                // ,
                // filter(v => v !== null)
            );
    }

    public getStationsComplete(connected: EnumConnectionType = EnumConnectionType.ALL, filterBy: EnumStationFilterType = EnumStationFilterType.NONE, i_station_ids_or_business_ids: Array<Id> = [], stationVersion: Id = null): Observable<Array<IStationData>> {
        const stations$ = this.m_user.dashboard ? of([]) : this.getStations(true);
        const stationGeoIPs$ = this.getStationGeoIPs();
        const stationStats$ = this.getStationStats();
        return combineLatest([stations$, stationStats$, stationGeoIPs$]).pipe(map(([stations, stationStats, stationGeos]) => {
            let stationsComplete: Array<IStationData> = [];
            if (this.m_user.dashboard) {
                stations = [];
                stationStats.forEach((s) => {
                    stations.push({
                        station_business_id: s.$.station_business_id,
                        station_id: s.$.id,
                        station_name: s.$.name,
                        tree_path: s.$.tree_path
                    });
                });
            }
            // /** if we found new stations that were just registered **/
            // if (stationStats?.length > 0 && stationStats?.length > stations?.length) {
            //     this.getChangelistIds()
            //         .pipe(
            //             debounceTime(3000),
            //             take(1))
            //         .subscribe((i_changelistIds) => {
            //             this.dispatchStaggered([
            //                 actionLoadAccountRequest({businessId: this.m_user.businessId, changelistId: i_changelistIds.changelistIdSync}),
            //                 actionLoadStationRequest({businessId: this.m_user.businessId})
            //             ], null, 2000);
            //         });
            // }
            if (!stations || stations.length === 0) return [];
            stations.forEach((i_station) => {
                const stationData: IStationData = {stat: null, props: null, geo: null};
                stationData.props = i_station;
                const stationStatsIndex = stationStats.findIndex((item) => item.$.station_business_id == i_station.station_business_id);
                if (stationStatsIndex > -1)
                    stationData.stat = stationStats[stationStatsIndex];
                const geoIndex = stationGeos.findIndex((item) => item.station_business_id == i_station.station_business_id);
                if (geoIndex > -1)
                    stationData.geo = stationGeos[geoIndex];
                stationsComplete.push(stationData);
            });
            if (stationVersion == '1' || stationVersion == '2') {
                stationsComplete = stationsComplete.filter((v) => {
                    if (stationVersion == '2') {
                        return v?.stat?.$?.version == stationVersion;
                    } else {
                        return v?.stat?.$?.version != '2';
                    }
                });
            }
            // if (filterBy == "NONE") doNothing();
            if (filterBy == EnumStationFilterType.BUSINESSES)
                stationsComplete = stationsComplete.filter((v) => i_station_ids_or_business_ids.indexOf(v.stat.$.businessId) > -1);
            if (filterBy == EnumStationFilterType.STATIONS)
                stationsComplete = stationsComplete.filter((v) => i_station_ids_or_business_ids.indexOf(v.stat.$.station_business_id) > -1);
            // if (connected == "ALL") doNothing();
            if (connected == EnumConnectionType.CONNECTED)
                stationsComplete = stationsComplete.filter((v) => {
                    if (v?.stat?.$?.version == '2') {
                        return v?.stat?.$?.connection == '1';
                    } else {
                        if (v?.stat?.$?.socket != '0') return true;
                        if (v?.stat?.$?.socket == '0' && v?.stat?.$?.connection == '2') return true; // polling mode
                        return false;
                    }
                });
            if (connected == EnumConnectionType.DISCONNECTED)
                stationsComplete = stationsComplete.filter((v) => {
                    if (v?.stat?.$?.version == '2') {
                        return v?.stat?.$?.connection !== '1';
                    } else {
                        if (v?.stat?.$?.socket == '0' && v?.stat?.$?.connection == '2') return false; // polling mode
                        return v?.stat?.$?.socket == '0';
                    }
                });
            return stationsComplete;
        }));
    }

    public getStationGeoIPs(): Observable<IStationGeoIp[]> {
        return this.getUser().pipe(
            map((i_user) => {
                if (i_user.dashboard) {
                    return this.store.select(appStore => appStore.enterprise.enterpriseStationGeoIPs).pipe(filter((data) => data !== null));
                } else {
                    return this.store.select(appStore => appStore.users.userStationGeoIPs).pipe(filter((data) => data !== null));
                }
            }),
            mergeMap(a => a)
        );
    }

    public getPreferences(): Observable<IPreferencesBusiness> {
        return this.store.select(appStore => appStore.users.preferences).pipe(filter((data) => data !== null));
    }

    public getTwoFactorState(): Observable<boolean> {
        return this.store.select(appStore => appStore.users.twoFactorState).pipe(filter((data) => data !== null));
    }

    public getFasterqLines(): Observable<List<FasterqLineModel>> {
        return this.store.select(appStore => appStore.fasterq.lines).pipe(filter((data) => data !== null));
    }

    public getFasterqTerminal(): Observable<FasterqLineModel> {
        return this.store.select(appStore => appStore.fasterq.terminal).pipe(filter((data) => data !== null));
    }

    public listenLogger(): Observable<ILog[]> {
        return this.store.select(store => store.config.logger);
    }

    public logger(i_data: ILog): void {
        const date = moment().format('MM-DD-YY|hh:mm:ss A');
        // if (Lib.DevShow(`logger ${i_data.severity} ${i_data.message}`);
        this.dispatch(actionLogger({log: {severity: i_data.severity, message: i_data.message, date}}));
    }

    public dispatchStaggered(dispatches: Array<Action>, startTime, timelapse) {
        if (!startTime) startTime = _.random(1, 1500);
        const intervals$ = timer(startTime, timelapse)
            .pipe(
                take(dispatches.length))
            .subscribe((count) => {
                const fire = dispatches.shift();
                this.dispatch(fire);
            });
    }

    public dispatch(action: Action) {
        // Lib.DevShow('dispatching ' + action.type);
        this.store.dispatch(action);
    }

    public get appStore() {
        return this.store;
    }

    public getUndoable(): Observable<boolean> {
        // return this.store.select((state) => !state.users.canUndo);
        return this.store.select(selectCanUndo()).pipe(map((canUndo) => !canUndo));
    }

    public getRedoable(): Observable<boolean> {
        // return this.store.select((state) => !state.users.canRedo);
        return this.store.select(selectCanRedo()).pipe(map((canRedo) => !canRedo));
    }

    public getPaints(): Observable<IPaintSource[]> {
        return this.store.select((state) => state.users.painters).pipe(filter((data) => data !== null));
    }

    public listenFasterqLines(): Observable<List<FasterqLineModel>> {
        return this.store.select(store => store.fasterq.lines);
    }

    public listenFasterqQueues(): Observable<List<FasterqQueueModel>> {
        const selected$ = this.store.select(store => store.config.fasterq.fasterqLineSelected);
        const queues$ = this.store.select(store => store.fasterq.queues);
        return combineLatest([selected$, queues$]).pipe(
            map(([lineId, queues]) => {
                return queues.filter((queue: FasterqQueueModel) => {
                    return queue.lineId == lineId;
                }) as List<FasterqQueueModel>;
            }),
            filter(value => value != null)
        );
    }

    public listenFasterqAnalytics(): Observable<List<FasterqAnalyticsModel>> {
        return this.store.select(store => store.fasterq.analytics);
    }

    public listenFasterqLineSelected(): Observable<FasterqLineModel> {
        const selected$ = this.store.select(store => store.config.fasterq.fasterqLineSelected);
        const lines$ = this.store.select(store => store.fasterq.lines);
        return combineLatest([selected$, lines$]).pipe(
            map(([lineId, lines]) => {
                return lines.find((line: FasterqLineModel) => {
                    return line.lineId == lineId;
                });
            }),
            filter(value => value != null)
        );
    }

    public listenFasterqQueueModelSelected(): Observable<FasterqQueueModel> {
        const selected$ = this.store.select(store => store.config.fasterq.fasterqQueueSelected);
        const queues$ = this.store.select(store => store.fasterq.queues);
        return combineLatest([selected$, queues$]).pipe(
            map(([serviceId, queues]) => {
                return queues.find((queue: FasterqQueueModel) => {
                    return queue.serviceId == serviceId;
                });
            }),
            filter(value => value != null)
        );
    }

    public listenFasterqQueueSelected(): Observable<any> {
        return this.store.select(store => store.config.fasterq.fasterqQueueSelected);
    }

    public listenFasterqQueueLastServicedPolled(): Observable<any> {
        return this.store.select(store => store.config.fasterq.fasterqNowServicing);
    }

    public getSvgColors(): Observable<ISVGConfig> {
        return this.store.select(store => store.config.uiSceneConfig.sceneItemSvgColor);
    }

    public listenCRUDScene(): Observable<ICRUDScene> {
        return this.store.select(store => store.users.crudScene);
    }

    public handleMimeAnomalies(i_sceneItem: ISceneBlock): MimeAnomalyType {
        switch (i_sceneItem.$.player) {
            case this.blockLabels.STOCKS.id: {
                return 'STOCKS';
            }
            case this.blockLabels.XML.id: {
                return 'XML';
            }
            case this.blockLabels.CATALOG.id: {
                return 'CATALOG';
            }
            case this.blockLabels.CUSTOMRSS.id: {
                return 'CUSTOM_RSS';
            }
            default: {
                const playerId = this.isBlockIdJsonAliased(i_sceneItem);
                switch (playerId) {
                    // case this.blockLabels.NETFEED_NEWS.id: {
                    //     return 'NETFEED_NEWS';
                    // }
                    // case this.blockLabels.NETFEED_HOROSCOPE.id: {
                    //     return 'NETFEED_HOROSCOPE';
                    // }
                    default: {
                        return 'JSON';
                    }
                }
            }
        }
    }

    /**  IUser: createSelector **/
    public getUserMemoize(): Observable<IUser> {
        return this.store.select(
            createSelector((state: IAppState) => state.users,
                (userState) => {
                    return userState.selectedUser;
                }
            )
        );
    }

    /**  createSelector combined **/
    public getUserCombinesExample(): Observable<string> {
        const users1$ = createSelector((state: IAppState) => state.users,
            (userState) => {
                return userState.selectedUser;
            }
        );
        const users2$ = createSelector((state: IAppState) => state.users,
            (userState) => {
                return userState.selectedUser;
            }
        );
        const selectFilteredItems = createSelector(users1$, users2$,
            (i_users1, i_users2) => {
                return i_users1.businessId;
            },
        );
        const finalObs$ = this.store.select(selectFilteredItems);
        return finalObs$;
    }

    /**  IUser: createSelector avoid creating createSelector everytime for best memoization combines slices **/
    getUserCombinesExample3(): Observable<IUser> {
        if (!this.selectorGetUsers$) {
            this.selectorGetUsers$ = createSelector((state: IAppState) => state.users.selectedUser, (userState) => userState);
        }
        return this.store.select(this.selectorGetUsers$)
            .pipe(map((v: IUser) => {
                    return v;
                })
            );
    }

    /**  IUserState: createSelector avoid creating createSelector everytime for best memoization combines slices **/
    getUserCombinesExample4(): Observable<IUserState> {
        if (!this.selectorGetUsers$) {
            this.selectorGetUsers$ = createSelector((state: IAppState) => state.users, (userState) => userState);
        }
        return this.store.select(this.selectorGetUsers$)
            .pipe(map((v: IUserState) => {
                    return v;
                })
            );
    }

    /**  IUserState | IUIConfigState: createSelector avoid creating createSelector everytime for best memoization combines slices **/
    getUserCombinesExample5(): Observable<{ u: IUser, c: IUIConfigState }> {
        if (!this.selectorCombined$) {
            // alert('create instance once selectorCombined$');
            const users = createSelector((state: IAppState) => state.users, (userState) => userState);
            const config = createSelector((state: IAppState) => state.config, (userState) => userState);
            this.selectorCombined$ = createSelector(users, config,
                (i_users1, i_config) => {
                    return {u: i_users1, c: i_config};
                },
            );
        }
        return this.store.select(this.selectorCombined$)
            .pipe(map((v: { u: IUser, c: IUIConfigState }) => {
                    return v;
                })
            );
    }

    public getAllEventBlocksInScenes(): Observable<Array<IEventBlock>> {
        return this.store.select(appStore => appStore.users.scenes).pipe(
            filter(data => data != null),
            map(data => {
                return getAllEventsInScenes(data);
            }));
    }

    public getAllEventsInSystem(): Observable<{ eventBlocks: Array<IEventBlock>, eventParams: Array<IEventParam> }> {
        const eventParams$ = this.getEventParams();
        const eventsScenes$ = this.getAllEventBlocksInScenes();
        return combineLatest([eventsScenes$, eventParams$])
            .pipe(
                map(([eventBlocks, eventParams]) => {
                    return {eventBlocks, eventParams};
                })
            );
    }

    public getAllEventsInSystemStructured(): Observable<{ eventBlocks: Array<IEventBlock>, eventParams: Array<IEventParam>, eventStrings: Array<string> }> {
        return this.getAllEventsInSystem().pipe(map((values) => {
            const eventParams = values.eventParams;
            const eventBlocks = _.cloneDeep(values.eventBlocks);
            let eventStrings = [...new Set(eventBlocks.map((b) => b.eventName))];
            eventParams.forEach((i_eventParam) => {
                const eventType = isArray(i_eventParam?.event_value) ? 'param list' : 'param object';
                eventBlocks.push({
                        eventName: i_eventParam.event_name,
                        eventType: eventType,
                        eventSceneId: 'none',
                        eventBlockId: i_eventParam?.event_param_id,
                        blockName: i_eventParam.event_name,
                        sceneName: 'event database',
                        eventBlockPlayer: eventType
                    }
                );
            });
            eventStrings = [...new Set(eventBlocks.map((b) => b.eventName))];
            return {eventParams, eventBlocks, eventStrings};
        }));
    }

    public getAllEventStringsInScenes(): Observable<Array<string>> {
        return this.store.select(appStore => appStore.users.scenes).pipe(
            filter(data => data != null),
            map(data => {
                return sceneFindEventInScenes(data, true);
            }));
    }
}



